import type { Program, ProgramEventContentObjectList } from 'models';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import { Button, Flex } from 'ui';
import { Attachments } from 'features/attachments';
import { EventContent } from '../event-content';
import { Footer } from '../footer';
import { LongTextContent } from '../long-text-content';
import { ProgramTimelineItemHeader } from '../program-timeline-item-header';

type P = {
  'data-test-id'?: string;
  item: ProgramEventContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramEventTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  const navigate = useNavigate();

  const isProgramPublished = program.status === 'published';

  return (
    <Flex data-test-id={dataTestId} gap={16} vertical>
      <ProgramTimelineItemHeader item={item} program={program} />
      <EventContent item={item} program={program} />
      <LongTextContent item={item} onCreateOrder={() => undefined} />
      <Attachments attachments={item.attachments} />
      <div>
        <Button
          onClick={async () => {
            await navigate(routes.contentObjects.events(item.event.id));
          }}
          type="primary"
        >
          Go to event
        </Button>
      </div>

      <Footer isProgramPublished={isProgramPublished} item={item} program={program} />
    </Flex>
  );
};

export default ProgramEventTimelineItem;
